import { Link } from 'react-router-dom';
import { articleData } from '@/mocks/articles';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://oopbuyspread.wiki';

const articleJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Article',
  headline: articleData.title,
  description: articleData.description,
  datePublished: articleData.date,
  author: {
    '@type': 'Organization',
    name: articleData.author,
  },
  publisher: {
    '@type': 'Organization',
    name: 'OOPBuy Spreadsheet',
    url: SITE_URL,
  },
  mainEntityOfPage: {
    '@type': 'WebPage',
    '@id': `${SITE_URL}/oopbuy-spreadsheet-guide`,
  },
  inLanguage: 'de',
};

export default function ArticlePage() {
  return (
    <div className="min-h-screen bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(articleJsonLd) }}
      />
      <header className="sticky top-0 z-40 bg-background-50/95 backdrop-blur-md border-b border-background-200/70">
        <div className="max-w-4xl mx-auto px-6 md:px-10">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center gap-2 group">
              <span className="w-5 h-5 flex items-center justify-center text-primary-500 group-hover:text-primary-600 transition-colors">
                <i className="ri-arrow-left-line"></i>
              </span>
              <span className="font-heading text-lg font-bold text-foreground-900 tracking-tight">
                oopbuy<span className="text-primary-500">spread</span>
              </span>
            </Link>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-1.5 px-4 py-2 text-sm font-semibold bg-primary-500 text-background-50 rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Buy It Now
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-sm"></i>
              </span>
            </a>
          </div>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 md:px-10 py-10 md:py-14">
        <nav className="mb-8" aria-label="Breadcrumb">
          <ol className="flex flex-wrap items-center gap-2 text-sm text-foreground-500">
            <li>
              <Link to="/" className="hover:text-primary-600 transition-colors">Startseite</Link>
            </li>
            <li>
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-s-line text-xs"></i>
              </span>
            </li>
            <li className="text-foreground-800 font-medium">OOPBuy Spreadsheet Guide</li>
          </ol>
        </nav>

        <article>
          <header className="mb-10">
            <span className="inline-block px-4 py-1.5 mb-5 text-xs font-semibold tracking-wider uppercase bg-accent-100 text-accent-800 rounded-full">
              Ultimativer Guide
            </span>
            <h1 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-foreground-900 leading-tight mb-4">
              {articleData.title}
            </h1>
            <p className="text-base md:text-lg text-foreground-600 leading-relaxed mb-6">
              {articleData.description}
            </p>
            <div className="flex flex-wrap items-center gap-4 text-sm text-foreground-500">
              <span className="flex items-center gap-1.5">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-calendar-line"></i>
                </span>
                {articleData.date}
              </span>
              <span className="flex items-center gap-1.5">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-user-line"></i>
                </span>
                {articleData.author}
              </span>
              <span className="flex items-center gap-1.5">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-time-line"></i>
                </span>
                Lesezeit: ~12 Minuten
              </span>
            </div>
          </header>

          <div className="w-full h-64 md:h-80 rounded-lg overflow-hidden mb-12">
            <img
              src="https://readdy.ai/api/search-image?query=Clean%20minimalist%20desk%20setup%20with%20laptop%20displaying%20spreadsheet%20data%20surrounded%20by%20fashion%20products%20sneakers%20hoodies%20accessories%20on%20light%20neutral%20surface%20soft%20natural%20daylight%20editorial%20product%20photography%20warm%20cream%20and%20beige%20tones%20airy%20composition%20professional%20yet%20casual%20vibe&width=1200&height=500&seq=article-header-2026&orientation=landscape"
              alt="OOPBuy Spreadsheet Guide Header"
              className="w-full h-full object-cover object-center"
            />
          </div>

          <div className="prose-custom">
            {articleData.sections.map((section, i) => (
              <section key={i} className="mb-10">
                <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-4">
                  {section.heading}
                </h2>
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed whitespace-pre-line">
                  {section.content}
                </p>
              </section>
            ))}
          </div>

          <div className="mt-14 p-6 md:p-8 bg-primary-50 border border-primary-200/60 rounded-lg">
            <h3 className="font-heading text-lg font-bold text-foreground-900 mb-3">
              Bereit für dein nächstes OOPBuy Erlebnis?
            </h3>
            <p className="text-sm text-foreground-600 mb-5">
              Nutze das Spreadsheet und entdecke die besten Produkte in allen Kategorien. Der schnellste Weg zum perfekten Fund.
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 text-sm font-semibold bg-primary-500 text-background-50 rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                oopbuy spreadsheet
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-external-link-line text-sm"></i>
                </span>
              </a>
              <Link
                to="/"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 text-sm font-semibold border-2 border-primary-200 text-primary-700 rounded-md hover:bg-primary-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                Zurück zur Startseite
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-left-line text-sm"></i>
                </span>
              </Link>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-200/70">
            <h4 className="font-heading text-base font-bold text-foreground-900 mb-4">Interne Links</h4>
            <ul className="flex flex-wrap gap-3">
              {articleData.internalLinks.map((link, i) => (
                <li key={i}>
                  <Link
                    to={link.url}
                    className="inline-flex items-center gap-1.5 px-4 py-2 text-sm font-medium bg-background-100 text-foreground-700 rounded-md hover:bg-primary-50 hover:text-primary-700 transition-colors cursor-pointer"
                  >
                    {link.text}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </article>
      </main>

      <footer className="w-full bg-background-100 border-t border-background-200/70">
        <div className="max-w-4xl mx-auto px-6 md:px-10 py-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <Link to="/" className="font-heading text-lg font-bold text-foreground-900 tracking-tight">
            oopbuy<span className="text-primary-500">spread</span>.wiki
          </Link>
          <p className="text-xs text-foreground-500">
            &copy; 2026 oopbuyspread.wiki – Unabhängige Informationsplattform
          </p>
        </div>
      </footer>
    </div>
  );
}